<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Contact" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-input
                  label="Section First Title"
                  v-model="sectionFirstTitle"
                  :error="!!errors.contact_about_section_first_title"
                  :error-messages="errors.contact_about_section_first_title"
                  @input="delete errors.contact_about_section_first_title"
                />
                <va-input
                  label="Section Second Title"
                  v-model="sectionSecondTitle"
                  :error="!!errors.contact_about_section_second_title"
                  :error-messages="errors.contact_about_section_second_title"
                  @input="delete errors.contact_about_section_second_title"
                />
                <va-input
                  label="Title"
                  v-model="title"
                  :error="!!errors.contact_about_title"
                  :error-messages="errors.contact_about_title"
                  @input="delete errors.contact_about_title"
                />
                <va-input
                  label="Address 1"
                  v-model="address1"
                  :error="!!errors.contact_about_address1"
                  :error-messages="errors.contact_about_address1"
                  @input="delete errors.contact_about_address1"
                />
                <va-input
                  label="Address 2"
                  v-model="address2"
                  :error="!!errors.contact_about_address2"
                  :error-messages="errors.contact_about_address2"
                  @input="delete errors.contact_about_address2"
                />
                <va-input
                  label="Phone"
                  v-model="phone"
                  :error="!!errors.contact_about_phone"
                  :error-messages="errors.contact_about_phone"
                  @input="delete errors.contact_about_phone"
                />
                <va-input
                  label="Email"
                  v-model="email"
                  :error="!!errors.contact_about_email"
                  :error-messages="errors.contact_about_email"
                  @input="delete errors.contact_about_email"
                />
                <va-input
                  type="textarea"
                  label="Map"
                  v-model="map"
                  :error="!!errors.contact_about_map"
                  :error-messages="errors.contact_about_map"
                  @input="delete errors.contact_about_map"
                />
                <va-button
                  @click="validate()"
                >Save</va-button>
              </div>
              <div class="flex xs12" v-if="tabValue === 1">
                <va-input
                  label="Meta Title"
                  v-model="metaTitle"
                  :error="!!errors.home_seo_title"
                  :error-messages="errors.home_seo_title"
                  @input="delete errors.home_seo_title"
                />
                <va-input
                  label="Meta Description"
                  type="textarea"
                  v-model="metaDescription"
                  :error="!!errors.home_seo_description"
                  :error-messages="errors.home_seo_description"
                  @input="delete errors.home_seo_description"
                />
                <va-input
                  label="Seo Title"
                  v-model="seoTitle"
                  :error="!!errors.home_seo_seo_title"
                  :error-messages="errors.home_seo_seo_title"
                  @input="delete errors.home_seo_seo_title"
                />
                <div style="margin-bottom: 15px;">
                  <span>Seo Text</span>
                  <ckeditor v-model="seoText" :editor="editor" :config="editorConfig"></ckeditor>
                  <div v-if="errors.home_seo_text" style="color: red;">{{ errors.home_seo_text[0] }}</div>
                </div>
                <va-input
                  label="SEO OpenGraph Title"
                  v-model="seoOpenGraphTitle"
                  :error="!!errors.home_seo_og_title"
                  :error-messages="errors.home_seo_og_title"
                  @input="delete errors.home_seo_og_title"
                />
                <va-input
                  type="textarea"
                  label="SEO OpenGraph Description"
                  v-model="seoOpenGraphDescription"
                  :error="!!errors.home_seo_og_description"
                  :error-messages="errors.home_seo_og_description"
                  @input="delete errors.home_seo_og_description"
                />
                <va-card class="mb-3" title="SEO OpenGraph Image">
                  <div v-if="seoOpenGraphImageExisting">
                    <a style="display: block;" target="_blank" :href="seoOpenGraphImageExisting"><img style="max-width: 400px;" :src="seoOpenGraphImageExisting"></a>
                    <div><va-button small color="danger" @click="seoOpenGraphImageExisting = deleteImage(seoOpenGraphImageId, 'contact_seo_og_image') ? '' : seoOpenGraphImageExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    type="gallery"
                    dropzone
                    @input="delete errors.contact_seo_og_image"
                    v-model="seoOpenGraphImage"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('contact_seo_og_image', 'contact_seo_og_image', seoOpenGraphImage[0])">Завантажити</va-button>
                  <div v-if="errors.contact_seo_og_image" style="color: red;">{{ errors.contact_seo_og_image[0] }}</div>
                </va-card>
                <va-button
                  @click="validate()"
                >Save</va-button>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CKEditor from '@ckeditor/ckeditor5-vue'
import '@ckeditor/ckeditor5-build-classic/build/translations/uk'

export default {
  name: 'grid',
  components: {
    ckeditor: CKEditor.component,
  },
  data () {
    return {
      sectionFirstTitle: '',
      sectionSecondTitle: '',
      title: '',
      address1: '',
      address2: '',
      phone: '',
      email: '',
      map: '',

      metaTitle: '',
      metaDescription: '',
      seoTitle: '',
      seoText: '',
      seoOpenGraphTitle: '',
      seoOpenGraphDescription: '',
      seoOpenGraphImage: [],
      seoOpenGraphImageId: '',
      seoOpenGraphImageExisting: '',

      errors: [],

      editor: ClassicEditor,
      editorConfig: {
        language: 'uk',
        simpleUpload: {
          uploadUrl: `${process.env.VUE_APP_SHKIL_API_URL}/admin/editor/upload`,
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        },
      },

      tabTitles: ['Main', 'Seo'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    locale () {
      return Vue.i18n.locale()
    },
    putData () {
      return {
        contact_about_section_first_title: this.sectionFirstTitle,
        contact_about_section_second_title: this.sectionSecondTitle,
        contact_about_title: this.title,
        contact_about_address1: this.address1,
        contact_about_address2: this.address2,
        contact_about_phone: this.phone,
        contact_about_email: this.email,
        contact_about_map: this.map,

        contact_seo_title: this.metaTitle,
        contact_seo_description: this.metaDescription,
        contact_seo_seo_title: this.seoTitle,
        contact_seo_text: this.seoText,
        contact_seo_og_title: this.seoOpenGraphTitle,
        contact_seo_og_description: this.seoOpenGraphDescription,
      }
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    uploadImage (param, key, file, agg = 'contact') {
      if (!file) {
        return
      }
      const formData = new FormData()
      formData.append(param, file)
      formData.append('lang', this.locale)
      formData.append('aggregate', agg)
      formData.append('key', key)
      formData.append('multiple', '0')
      formData.append('file_id', '0')
      axios.post(`${process.env.VUE_APP_SHKIL_API_URL}/admin/site-page/upload/2?lang=${this.locale}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          this.showToast('Successful upload')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    async deleteImage (id, fieldKey) {
      return axios.post(`${process.env.VUE_APP_SHKIL_API_URL}/admin/site-page/2/delete-file/${id}?lang=${this.locale}`, {
        key: fieldKey,
      })
        .then(() => {
          this.showToast('Successfully deleted')
        })
        .catch(() => {
          this.showToast('Error')
        })
    },
    submit () {
      axios.put(`${process.env.VUE_APP_SHKIL_API_URL}/admin/site-page/2?lang=${this.locale}`, this.putData)
        .then(response => {
          this.showToast('Successful update')
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
          }
          this.showToast('Error')
        })
    },
    validate () {
      axios.put(`${process.env.VUE_APP_SHKIL_API_URL}/admin/site-page/validate/2?lang=${this.locale}`, this.putData, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(response => {
          this.errors = response.data
          if (!Object.keys(this.errors).length) {
            this.submit()
          }
        })
        .catch(error => {
          console.log(error)
          this.showToast('Validate Fetch Error')
        })
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_SHKIL_API_URL}/admin/site-page/2?lang=${this.locale}`)
        .then(response => {
          this.sectionFirstTitle = response.data.contact_about_section_first_title ? response.data.contact_about_section_first_title : ''
          this.sectionSecondTitle = response.data.contact_about_section_second_title ? response.data.contact_about_section_second_title : ''
          this.title = response.data.contact_about_title
          this.address1 = response.data.contact_about_address1
          this.address2 = response.data.contact_about_address2
          this.phone = response.data.contact_about_phone
          this.email = response.data.contact_about_email
          this.map = response.data.contact_about_map

          this.metaTitle = response.data.contact_seo_title ? response.data.contact_seo_title : ''
          this.metaDescription = response.data.contact_seo_description ? response.data.contact_seo_description : ''
          this.seoTitle = response.data.contact_seo_seo_title ? response.data.contact_seo_seo_title : ''
          this.seoText = response.data.contact_seo_text ? response.data.contact_seo_text : ''
          this.seoOpenGraphTitle = response.data.contact_seo_og_title ? response.data.contact_seo_og_title : ''
          this.seoOpenGraphDescription = response.data.contact_seo_og_description ? response.data.contact_seo_og_description : ''
          this.seoOpenGraphImageExisting = response.data.contact_seo_og_image ? process.env.VUE_APP_SHKIL_ADMIN + response.data.contact_seo_og_image : null
          this.seoOpenGraphImageId = response.data.contact_seo_og_image_id
        })
        .catch(error => {
          console.log(error.response)
        })
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}

.va-file-upload-gallery-item {
  flex-basis: unset;
  max-width: 400px;
  width: unset;
}
</style>
